<template>
  <div>
    <security-mask
      v-if="securityMaskingEnabled"
      :masked-values="securityMaskedValues"
      :class="commonEntriesPropertiesCssClasses"
      v-tooltip.wrap="tooltipText"
      v-bind="$attrs"
    ></security-mask>
    <input v-else type="text" :class="entriesPropertiesCssClasses" v-tooltip.wrap="tooltipText" disabled :value="localValue" @input="" v-bind="$attrs">
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import objectModelEntryPropertiesMixin from "~/mixins/objectModelEntries/objectModelEntryPropertiesMixin";
import localValueEmissionMixin from "~/mixins/localValueEmissionMixin";
import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
import SecurityMask from "./object-model-entry-security-mask.vue";

export default Vue.extend({
  mixins: [objectModelEntryPropertiesMixin, localValueEmissionMixin],
  components: {
    SecurityMask,
  },
  computed:{
    tooltipText(){
      switch (this.objectModelPropertyType){
        case ObjectModelPropertyRootType.Aggregate:
        case ObjectModelPropertyRootType.DerivedField:
        case ObjectModelPropertyRootType.RelationshipCount:
          return "This value is calculated with a formula and cannot be edited."
        case ObjectModelPropertyRootType.MappedProperty:
          return "This value is pulled from another record and cannot be edited here. Edits can be made on the <Relation Name>."
        case ObjectModelPropertyRootType.AutoIncrement:
          return "This value is determined on creation of the record and cannot be edited"


      }
    },
    securityMaskedValues(): {unmasked?: string, masked: string} {
      return this.entry[`f_${this.objectModelProperty.client_id}_display`];
    },
    securityMaskingEnabled(): boolean {
      return this.disabled && this.objectModelProperty.security_maskable_enabled && this.securityMaskedValues;
    },
    entriesPropertiesCssClasses() {
      return {
        'read-only': this.isReadOnly
      }
    }
  },
});
</script>